import React from 'react';
import { GridColumn as Column } from "@progress/kendo-react-grid";
import { Button } from '@progress/kendo-react-buttons';
import { DropDownList } from "@progress/kendo-react-dropdowns";
import CurrencyContainer from '../CurrencyContainer';
import { isEmpty, /*removeSpaces, */convertDatestampToObject, getLocaleDateString } from '../../helpers';
import { ExcelExport, ExcelExportColumn } from "@progress/kendo-react-excel-export";
import { AppContext } from "../../context/AppContext";
//import isPage from '../../hoc/isPage';
import hasData from '../../hoc/hasData';
import { compose } from 'redux';
import goalMet from '../../img/tick.svg';
import goalNotMet from '../../img/warning.svg';
import editIcon from '../../img/icon-edit.png';
import deleteIcon from '../../img/icon-delete.png';
//import checkedRedIcon from '../../img/icon-checked-red.png';
//import uncheckedIcon from '../../img/icon-unchecked.png';
//import checkedDisabledIcon from '../../img/icon-checked-disabled.png';
//import uncheckedDisabledIcon from '../../img/icon-unchecked-disabled.png';
//import checkedEnabledIcon2 from '../../img/icon-checked-enabled2.svg';
//import checkedEnabledHoverIcon2 from '../../img/icon-checked-enabled-hover2.svg';
//import uncheckedEnabledIcon2 from '../../img/icon-unchecked-enabled2.svg';
//import uncheckedEnabledHoverIcon2 from '../../img/icon-unchecked-enabled-hover2.svg';
import checkedDisabledIcon2 from '../../img/icon-checked-disabled2.svg';
import warningIcon2 from '../../img/icon-warning2.svg';
import greyWarningIcon2 from '../../img/icon-warning-grey2.svg';
import gearIcon from '../../img/icon-gear.svg';
//import demandIcon from '../../img/icon-demand.png';
import demandIcon2 from '../../img/icon-demand-2.png';


import PropTypes from 'prop-types';
import moment from 'moment';
import localize from '../../hoc/localize';


export const defaultGridProperties = {
    resizable: true,
    reorderable: true

}

export class DateCell extends React.Component {
    render() {
        const localeDateString = getLocaleDateString().toUpperCase();
        const value = this.props.dataItem[this.props.field];
        const { className } = this.props;
        if (className)
            return (
                <td className={className}>
                    {
                        (value === null) ? '' : moment(convertDatestampToObject(value)).format(localeDateString)
                    }
                </td>
            );
        else
            return (
                <td>
                    {
                        (value === null) ? '' : moment(convertDatestampToObject(value)).format(localeDateString)
                    }
                </td>
            );
    }
}

export class PercentCell extends React.Component {
    render() {
        const value = this.props.dataItem[this.props.field];
        return (
            <td className="numeric">
                {
                    (value === null) ? '' : `${value}%`
                }
            </td>
        );
    }
}

export class CurrencyCell extends React.Component {
    render() {
        let value = this.props.dataItem[this.props.field];
        if (value === null) value = 0;
        return (
            <td className="numeric">
                <CurrencyContainer quantity={value} />
            </td>
        )
    }
}

export class BlankCell extends React.Component {
    render() {

        return (
            <td></td>
        );
    }
}

export class BlankColumn extends React.Component {
    render() {
        return (
            <Column
                {...this.props} />
        )
    }
}

export class BooleanCell extends React.Component {
    //constructor(props) {
    //    super(props);
    //    this.state = {
    //        isGoing: false
    //    };

    //    this.handleInputChange = this.handleInputChange.bind(this);
    //}

    //handleInputChange(event) {
    //    const target = event.target;
    //    const value = target.type === 'checkbox' ? target.checked : target.value;
    //    const name = target.name;

    //    this.setState({
    //        [name]: value
    //    });
    //}

    render() {

        const value = this.props.dataItem[this.props.field];
        const { editable } = this.props;


        if (value === null) {
            return (
                <td className="boolean"></td>
            )
        } else {
            const checked = (value === true || value === "on");
            if (editable) {
                //name="isGoing"
                //onChange = {this.handleInputChange}
                return (
                    <td className="boolean" >
                        <input
                            type="checkbox"
                            readOnly
                            checked={checked} />
                        <label onClick={this.props.handleChange} />
                    </td>
                );
                ////return (
                ////    <td className="boolean" >
                ////        <img onClick={this.props.handleChange} style={{ cursor: 'pointer', width: 30, height: 30 }} src={checked ? checkedRedIcon : uncheckedIcon} />
                ////    </td>
                ////)
                //if (checked)
                //    //return (
                //    //    <td className="boolean" >
                //    //        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={this.props.handleChange} style={{ cursor: 'pointer' }} >
                //    //            <rect width="20" height="20" rx="2" fill="#429DD6" />
                //    //            <path d="m8.24333,12.74775l-2.41889,-2.41889l-0.82444,0.82445l3.24333,3.23555l6.9611,-6.96111l-0.8244,-0.81667l-6.1367,6.13667z" fill="white" />
                //    //        </svg>
                //    //    </td>
                //    //);
                //    //<img onClick={this.props.handleChange} style={{ cursor: 'pointer', width: 20, height: 20 }} className="not-hover" src={checkedEnabledIcon2} alt="V" />
                //    //<img onClick={this.props.handleChange} style={{ cursor: 'pointer', width: 20, height: 20 }} className="hover" src={checkedEnabledHoverIcon2} />
                //    return (
                //        <td className="boolean" >
                //            <input type="checkbox" checked /><label onClick={this.props.handleChange} />
                //        </td>
                //    );
                //else
                //    //return (
                //    //    <td className="boolean" >
                //    //        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={this.props.handleChange} style={{ cursor: 'pointer' }} >
                //    //            <rect x="0.5" y="0.5" width="19" height="19" rx="1.5" fill="white" stroke="#CAD0DF" />
                //    //        </svg>
                //    //    </td>
                //    //);
                //    //<img onClick={this.props.handleChange} style={{ cursor: 'pointer', width: 20, height: 20 }} className="not-hover" src={uncheckedEnabledIcon2} />
                //    //<img onClick={this.props.handleChange} style={{ cursor: 'pointer', width: 20, height: 20 }} className="hover" src={uncheckedEnabledHoverIcon2} />
                //    return (
                //        <td className="boolean" >
                //            <input type="checkbox" unchecked="true" /><label onClick={this.props.handleChange} />
                //        </td>
                //    );
            } else {
                //return (
                //    <td className="boolean" >
                //        <img style={{ width: 30, height: 30 }} src={checked ? checkedDisabledIcon : uncheckedDisabledIcon} />
                //    </td>
                //);
                if (checked)
                    //return (
                    //    <td className="boolean" >
                    //        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
                    //            <path d="M0 0h18v18H0z" fill="none" />
                    //            <path d="M6.61 11.89L3.5 8.78 2.44 9.84 6.61 14l8.95-8.95L14.5 4z" />
                    //        </svg>
                    //    </td>
                    //);
                    return (
                        <td className="boolean" >
                            <img style={{ width: 18, height: 18 }} src={checkedDisabledIcon2} alt="V" />
                        </td>
                    );
                else
                    return (
                        <td className="boolean" >-</td>
                    );
            }
        }
    }
}

BooleanCell.propTypes = {
    dataItem: PropTypes.object,
    editable: PropTypes.bool,
    handleChange: PropTypes.func
}
BooleanCell.defaultProps = {
    editable: false
}

export class GoalMetCell extends React.Component {
    render() {
        const value = this.props.dataItem[this.props.field];
        return (
            <td > {
                (value === null) ? '' : (value === "1") ? <img src={goalMet} className="svg-icon" alt="V" /> : <img src={goalNotMet} className="svg-icon" alt="!" />}
            </td>
        );
    }
}

export class ButtonCell extends React.Component {
    static propTypes = {
        text: PropTypes.string.isRequired,
        handleClick: PropTypes.func,
        disabled: PropTypes.bool
    }
    render() {
        return (
            <td>
                <Button look="default" disabled={this.props.disabled} onClick={this.props.handleClick}>{this.props.text}</Button>
            </td>
        )
    }
}
ButtonCell.defaultProps = {
    disabled: false
}



class ExcelExportButtonCell extends React.Component {
    _export;
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }
    static propTypes = {
        text: PropTypes.string.isRequired
    }

    handleClick = () => {
        this._export.save(this.props.dataItem.parts);
        //this._export.save();

        if (this.props.dataItem.suggestedPOID) {
            // 5: SuggestedPO Exported - XLS
            this.props.postData(`/api/portal/admin/user/LogEvent/5/${this.props.dataItem.suggestedPOID}`).catch((error) => {
                this.props.alert("error", this.props.returnLocalizedString("m0023"), error.message)
            })
        }
    }

    getFileName = (data, fileExtension) => {
        // dealer name - vendor code - order date - extension
        const dealerName = data.dealerName;
        const vendorCode = data.vendorCode;

        const orderDate = moment(data.orderDate, "YYYYMMDD").format("YYYY-MM-DD");

        //let fileName = `${removeSpaces(dealerName)}-${vendorCode}`;
        let fileName = `${dealerName.replace(/\s/g, '-')}-${vendorCode}`;
        switch (parseInt(this.orderType, 10)) {
            case 1:
                fileName = `${fileName}-GM`;
                break;
            case 2:
                fileName = `${fileName}-P&A`;
                break;
            default:
                break;
        }

        return `${fileName}-${orderDate}.${fileExtension}`;
    }

    render() {
        const data = this.props.dataItem;
        let excelFileName;
        const disabled = !(data.parts && data.parts[0].partNumber !== null);
        if (!disabled) {
            if (!isEmpty(this.context.state.selectedOrderType)) {
                this.orderType = this.context.state.selectedOrderType
                    ? this.context.state.selectedOrderType.orderTypeID
                    : null;
            }

            excelFileName = this.getFileName(data, 'xlsx');
        }

        //!DBTRANS! @m0191@ Part Number !DEVNOTE! Input field label
        //!DBTRANS! @m0314@ Suggested Qty !DEVNOTE! Column label
        //!DBTRANS! @m0315@ Order Qty !DEVNOTE! Column label
        //!DBTRANS! @m0316@ Pkg !DEVNOTE! Column label
        //!DBTRANS! @m0317@ Units/Pkg !DEVNOTE! Column label
        //!DBTRANS! @m0318@ Cost !DEVNOTE! Column label
        //!DBTRANS! @m0267@ Total !DEVNOTE! Time label


        return (
            <td style={{ textAlign: "center" }}>
                <Button look="default" disabled={disabled} onClick={this.handleClick}>{this.props.text}</Button>
                <ExcelExport
                    data={data.parts}
                    ref={exporter => {
                        this._export = exporter;
                    }}
                    fileName={excelFileName}
                >
                    <ExcelExportColumn
                        field="partNumber"
                        title={this.props.returnLocalizedString("m0191")}
                        width={200} />
                    <ExcelExportColumn
                        field="partDescription"
                        title="Description"
                        width={250}
                    />
                    <ExcelExportColumn
                        field="suggestedQty"
                        title={this.props.returnLocalizedString("m0314")}
                        width={150}
                        className="numeric"
                        headerClassName="numeric"
                    />
                    {this.context.state.allowEditSuggestedOrders ?
                        <ExcelExportColumn
                            key="orderQty"
                            field="orderQty"
                            title={this.props.returnLocalizedString("m0315")}
                            width={150}
                            className="numeric"
                            headerClassName="numeric"
                        /> : <React.Fragment />}

                    <ExcelExportColumn
                        field="package"
                        title={this.props.returnLocalizedString("m0316")}
                        headerClassName="boolean"
                        className="boolean"
                        width={90}
                        cell={props => (
                            <BooleanCell mode="checkbox" {...props} />
                        )}
                    />
                    <ExcelExportColumn
                        field="packageCount"
                        title={this.props.returnLocalizedString("m0317")}
                        width={150}
                        className="numeric"
                        headerClassName="numeric"
                    />

                    <ExcelExportColumn
                        field="cost"
                        title={this.props.returnLocalizedString("m0318")}
                        width={100}
                        className="numeric"
                        headerClassName="numeric"
                        cell={props => (
                            <CurrencyCell {...props} />
                        )}
                    />
                    <ExcelExportColumn
                        field="total"
                        title={this.props.returnLocalizedString("m0267")}
                        width={125}
                        className="numeric"
                        headerClassName="numeric"
                        cell={props => (
                            <CurrencyCell {...props} />
                        )}
                    />
                </ExcelExport>
            </td>
        )
    }
}
ExcelExportButtonCell.displayName = "ExcelExportButtonCell";
ExcelExportButtonCell.contextType = AppContext;
ExcelExportButtonCell.defaultProps = {
    disabled: false
}
export default compose(localize, hasData)(ExcelExportButtonCell);

export class IconButtonCell extends React.Component {
    static propTypes = {
        icon: PropTypes.string.isRequired,
        title: PropTypes.string,
        handleClick: PropTypes.func,
        disabled: PropTypes.bool
    }
    render() {
        let icon;
        let imageUrl;
        let showButton = true;
        switch (this.props.icon.toLowerCase()) {
            case "edit":
                if (this.props.dataItem['partExceptionsExist'] === 0)
                    imageUrl = gearIcon;
                else if (this.props.dataItem['partExceptionsExist'] === 1)
                    imageUrl = warningIcon2;
                else if (this.props.dataItem['partExceptionsExist'] === 2)
                    imageUrl = greyWarningIcon2;
                else
                    icon = this.props.icon.toLowerCase();
                break;
            case "details":
                imageUrl = demandIcon2;
                if (this.props.dataItem['quantitySold'] === null)
                    // quantitySold is null indicates the part is from other store
                    showButton = false;
                break;
            case "delete":
                icon = this.props.icon.toLowerCase();
                break;
            default:
                icon = this.props.icon.toLowerCase();
                break;
        }
        //{ icon }
        return (
            <td className="icon-button">
                {showButton && (
                    <Button look="bare" icon={icon} title={this.props.title} imageUrl={imageUrl} imageAlt={this.props.title} disabled={this.props.disabled} onClick={this.props.handleClick}></Button>)
                }
            </td>
        )
    }
}
IconButtonCell.defaultProps = {
    disabled: false
}

export class EditCell extends React.Component {

    static propTypes = {
        dataItemKey: PropTypes.string.isRequired
    }

    handleClick = () => {

        this.props.handleEdit(this.props.dataItem[this.props.dataItemKey]);
    }

    render() {
        const style = { 'width': 20, 'height': 20 };
        return (
            <td>
                {/*<img className="svg-icon" onClick={this.handleClick} src={editIcon} style={style}/>*/}
                <img src={editIcon} onClick={this.handleClick} style={style} className="cursor-pointer" alt="" />
            </td>
        );
    }
}

export class DeleteCell extends React.Component {

    static propTypes = {
        dataItemKey: PropTypes.string.isRequired
    }

    handleClick = () => {
        this.props.handleDelete(this.props.dataItem[this.props.dataItemKey]);
    }

    render() {
        const style = { 'width': 20, 'height': 20 };
        return (
            <td>
                {/*<img className="svg-icon" onClick={this.handleClick} src={deleteIcon} style={style}/>*/}
                <img src={deleteIcon} style={style} onClick={this.handleClick} className="cursor-pointer" alt="" />
            </td>
        );
    }
}

// works the same as DropDownFilterCell below, but is meant to work against columns whose data is an array of values
export class DropDownFilterArrayCell extends React.Component {
    static propTypes = {
        data: PropTypes.array,
        defaultItem: PropTypes.string
    }
    static includes = (currentFieldValue, selectedFilterValue) => {
        //console.log('includes', currentFieldValue, selectedFilterValue, currentFieldValue.includes(selectedFilterValue));
        //console.log('includes_test', currentFieldValue, selectedFilterValue, currentFieldValue.map((a) => { return a.toLowerCase() }).includes(selectedFilterValue.toLowerCase()));

        //return currentFieldValue.includes(selectedFilterValue);
        return currentFieldValue.map((a) => { return a.toLowerCase() }).includes(selectedFilterValue.toLowerCase());
        //return true;
    }
    hasValue(value) {
        //console.log('hasValue', value, this.props.defaultItem);
        return value && value !== this.props.defaultItem;
    }

    render() {
        const { data, defaultItem } = this.props;
        //console.log('DropDownFilterCell', data);
        return (
            <div className="k-filtercell">
                <DropDownList
                    data={data}
                    onChange={(event) => {
                        const hasValue = this.hasValue(event.target.value);
                        //console.log(event);
                        this.props.onChange({
                            value: hasValue ? event.target.value : '',
                            //operator: hasValue ? 'eq' : '',
                            operator: hasValue ? DropDownFilterArrayCell.includes : '',
                            syntheticEvent: event.syntheticEvent
                        });
                    }}
                    value={this.props.value || defaultItem}
                    defaultItem={defaultItem}
                />
                <button
                    className="k-button k-button-icon k-clear-button-visible"
                    title="Clear"
                    disabled={!this.hasValue(this.props.value)}
                    onClick={(event) => {
                        event.preventDefault();
                        this.props.onChange({
                            value: '',
                            operator: '',
                            syntheticEvent: event
                        });
                    }}
                >
                    <span className="k-icon k-i-filter-clear" />
                </button>
            </div>
        );
    }
}
DropDownFilterArrayCell.defaultProps = {
    defaultItem: "(All)",
    data: []
}

// reference:
// https://stackblitz.com/run/?file=app%2Fmain.js

// example of usage:
// <Column 
//      field="Category.CategoryName" 
//      filterCell={(props) => 
//            <DropDownFilterCell 
//                data={this.getUniqueCategories()} 
//                defaultItem="Select category" 
//                {...props} />} 
//      title="Category" 
// />
export class DropDownFilterCell extends React.Component {
    static propTypes = {
        data: PropTypes.array,
        defaultItem: PropTypes.string
    }
    hasValue(value) {
        return value && value !== this.props.defaultItem;
    }
    render() {
        const { data, defaultItem } = this.props;

        return (
            <div className="k-filtercell">
                <DropDownList
                    data={data}
                    onChange={(event) => {
                        const hasValue = this.hasValue(event.target.value);
                        this.props.onChange({
                            value: hasValue ? event.target.value : '',
                            operator: hasValue ? 'eq' : '',
                            syntheticEvent: event.syntheticEvent
                        });
                    }}
                    value={this.props.value || defaultItem}
                    defaultItem={defaultItem}
                />
                <button
                    className="k-button k-button-icon k-clear-button-visible"
                    title="Clear"
                    disabled={!this.hasValue(this.props.value)}
                    onClick={(event) => {
                        event.preventDefault();
                        this.props.onChange({
                            value: '',
                            operator: '',
                            syntheticEvent: event
                        });
                    }}
                >
                    <span className="k-icon k-i-filter-clear" />
                </button>
            </div>
        );
    }
}
DropDownFilterCell.defaultProps = {
    defaultItem: "(All)",
    data: []
}


// WEBPACK FOOTER //
// ./src/components/utils/GridHelpers.js